import { State } from 'src/redux/reducer';
import { isLoaded } from 'src/redux/utils';
import { TestState } from './types';

export const testDataAllSelector = (state: State): TestState => state.testData;

export const testDataStatusSelector = (state: State) =>
  state.testData.statusLoads;

export const testDataLoadedSelector = isLoaded(testDataStatusSelector);
